import React from 'react';

import {
  WysiwygField,
  Button,
} from '../../../components';

const ParagraphDownload = ({ entity }) => {
  return (
    <div className="Paragraph ParagraphDownload">
      <h2 className="ParagraphDownload__title">
        {entity.getIn(['field_title', 0, 'value'])}
      </h2>
      <WysiwygField
        property="schema:text"
        className="ParagraphDownload__text p"
        html={entity.getIn(['field_text', 0, 'processed'])}
      />
      {entity.getIn(['field_attachments']).map((file) => (
        <div
          key={`${file.get('target_id')}:${file.get('bundle')}`}
          className="u-margin--bottom--2"
        >
          <Button
            type="secondary"
            icon="download"
            href={file.get('source')}
          >
            {file.get('title')}
          </Button>
        </div>
      ))}
    </div>
  );
};

export default ParagraphDownload;
